module.exports = __webpack_public_path__ + "images/category_lp/pc/lp-pc-shop-image6_2e018027633f095724cf02c4c34ddffc.png";